import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionPool } from './competition-pool'
import { CompetitionPoolSerializer } from './competition-pool.serializer'

@Injectable()
export class CompetitionPoolService extends ResourceService<CompetitionPool> {
  constructor(
    private http: HttpClient,
    private competitionPoolSerializer: CompetitionPoolSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-pools`,
      competitionPoolSerializer
    )
  }
}
